import MessengerModal from "./messengerModal";
import React, {useState} from "react";
import {Row} from "reactstrap";
import Col from "reactstrap/es/Col";
import {SmartDatepicker, SmartGroupVertical, SmartTextarea, useSmartForm} from "@csas-smart/smart-ui-comps";
import ActionsModalFooter from "./actionsModalFooter";
import {useDispatch, useSelector} from "react-redux";
import {fireSuspend} from "../../actions/humanTaskActions";
import {isUserInRoles} from "../stripe/utils/actionStripeConfig";

export const ActionsSuspendModal = ({isOpen, onToggle, submitText, header, processingText}) => {

    const smartForm = useSmartForm();
    const [note, setNote] = useState('');
    const [date, setDate] = useState('');

    const suspending = useSelector(state => state?.humanTask?.suspending);
    const cidla = useSelector(state => state?.messenger?.cidla);
    const user = useSelector(state => state?.user?.identity);

    const dispatch = useDispatch();

    const handleSubmit = () => {
        dispatch(fireSuspend(cidla, {"note": note, "suspendUntil" : new Date(date).getTime()})).then(() => handleToggle());
    };

    const handleValidatedSubmit = () => {
        smartForm.onSubmit(handleSubmit);
    };

    const handleToggle = () => {
        setDate('');
        setNote('');
        onToggle();
    };

    const isToday = (d) => {
        const today = new Date();
        const selected = d instanceof Date ? d : new Date(d);
        return selected.getDate() === today.getDate() &&
            selected.getMonth() === today.getMonth() &&
            selected.getFullYear() === today.getFullYear()
    }

    const getMinTime = () => {
        let today = new Date();
        if(!date || isToday(date)){
            return today;
        }

        today.setHours(0,0,0,0)
        return today;
    };

    const getMaxTime = () => {
        let secondToMidnight = new Date();
        secondToMidnight.setHours(23, 59, 59);
        return secondToMidnight;
    }

    const handleDateChange = (d) => {
        let selected =  new Date(d);
        let today = new Date();
        const checkToday = isToday(selected);
        if((!date && checkToday) || (d && date && checkToday && (selected.getHours() <= today.getHours()))){
            return setDate(d.setHours(today.getHours(), (today.getMinutes() > 30 ? 60 : 30), 0))
        }
        return setDate(d);
    };

    const getBody = () => {
        return (
            <>
                <Row>
                    <Col>
                        <p>Vyberte si, na kdy chcete konverzaci s klientem odložit:</p>
                        <SmartGroupVertical id="sgv-note" label="Poznámka"
                                            target="st-note">
                            <SmartTextarea rows={3}
                                           id="st-note"
                                           value={note}
                                           onChange={e => setNote(e.target.value)}/>
                        </SmartGroupVertical>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <SmartGroupVertical id="sgv-date" form={smartForm} label="Odložit do"
                                            target="st-date">
                            <SmartDatepicker id="st-date"
                                             form={smartForm}
                                             rules={{required:true}}
                                             className="d-block"
                                             placeholder="Vyberte datum"
                                             value={date}
                                             buttons="calendar"
                                             size="md"
                                             minTime={getMinTime()}
                                             maxTime={getMaxTime()}
                                             minDate={new Date()}
                                             clearable={true}
                                             withTime={true}
                                             dateFormat={["dd.MM.yyyy"]}
                                             onChange={(date) => handleDateChange(date)}/>
                        </SmartGroupVertical>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {isUserInRoles(user, ["SMART_MIT_solver_frontOffice", "SMART_MIT_solver_frontOfficeEP", "SMART_MIT_solver_frontOfficeEPB"]) ?
                            <p>Klient čeká na Vaši odpověď. Pokud se k řešení dostanete později, informujte o tom klienta. Ve vybraný čas Vám přijde e-mailová notifikace.</p> :
                            <p>Klient čeká na Vaši odpověď. Pokud se k řešení dostanete později, informujte o tom klienta.</p>
                        }
                    </Col>
                </Row>
            </>
        )
    };

    const getFooter = () => {
        let primary = {
            onClick: handleValidatedSubmit,
            text: submitText
        };

        let cancel = {
            onClick: handleToggle,
            text: 'Pokračovat v konverzaci'
        };

        return (
            <ActionsModalFooter primary={primary} cancel={cancel}/>
        )
    };

    return (
        <MessengerModal
            size="xs"
            processing={suspending.progress}
            processingText={processingText}
            error={suspending.error}
            isOpen={isOpen}
            onToggle={handleToggle}
            header={header}
            body={getBody()}
            footer={getFooter()}
        />
    )
};

export default ActionsSuspendModal;